/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Brea_TInputs */

const en_testimonial_brea_t = /** @type {(inputs: Testimonial_Brea_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Useful every day! This app legit turns anything into a podcast you can listen to in seconds. I can finally listen to all the newsletters and essays I'm subscribed to without spending hours in my email inbox! In particular, I appreciate using this app for long walks, chores around the house, and exercise. Listening also hooks up directly into any podcasting app so you don't need to manage more apps or sources of content, which is pretty nice.`)
};

const es_testimonial_brea_t = /** @type {(inputs: Testimonial_Brea_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Útil todos los días! Esta app literalmente convierte cualquier cosa en un podcast que puedes escuchar en segundos. ¡Por fin puedo escuchar todos los boletines y ensayos a los que estoy suscrito sin pasar horas en mi bandeja de entrada! En particular, aprecio usar esta app para caminatas largas, tareas del hogar y ejercicio. Listening también se conecta directamente con cualquier app de podcasts, lo cual es bastante conveniente.`)
};

/**
* | output |
* | --- |
* | "Useful every day! This app legit turns anything into a podcast you can listen to in seconds. I can finally listen to all the newsletters and essays I'm subsc..." |
*
* @param {Testimonial_Brea_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_brea_t = /** @type {((inputs?: Testimonial_Brea_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Brea_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_brea_t(inputs)
	return en_testimonial_brea_t(inputs)
});